import styled from 'styled-components';


const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
    cursor: default;
    user-select: none;
`;

const HeaderRow = styled.tr`
 height: 40px;
`;

const ColumnHeader = styled.th`
    background-color: #EDEFEF;
    white-space: nowrap;
    border-bottom: none;
    vertical-align: bottom;
    padding-bottom: 6px;
    text-align: left;
    padding-left: 10px;
    height: 40px;
    padding-right: 10px;
`;


const ColumnHeaderEdge = styled(ColumnHeader)`
    border-right: 2px solid #FFF;
`;

const TableRow = styled.tr`
    height: 30px;
    border: none;
`;


const TableCell = styled.td`
    border:none;
    padding-left: 10px;
    height: 30px;
    padding-right: 10px;
`;


export { Table, HeaderRow, ColumnHeaderEdge, ColumnHeader, TableRow, TableCell }